interface IAddressData {
  cityId: number;
  cityName: string;
  streetId?: number;
  streetName?: string;
  houseNumber: string;
  apartmentNumber?: string;
}

export function getSessionAddress(key: string): IAddressData | undefined {
  const sessionStorageAddress = sessionStorage.getItem(key);
  const address = sessionStorageAddress
    ? JSON.parse(sessionStorageAddress)
    : undefined;

  if (!address) {
    return;
  }

  return address;
}
